<template>
	<div id='zoompick'>
    <svg height='0'>
      <defs>
        <filter id='outofplane' x='0' y='0'>
          <feGaussianBlur in='SourceGraphic' stdDeviation='3'/>
        </filter>
      </defs>
    </svg>
    <div>
      <img style='position:relative' :src='url' :id='key' class="beerImg"  v-on:click="beerClick" v-for='(url, key, index) in images'> 
      </img>
      <slot></slot>
      <div v-if='zoomed' v-bind:style="{ marginLeft: slotPosition + 'px', marginTop: slotTop + 'px'}">
              <v-card style='position:relative'>
                <v-jumbotron color='black' dark>
                  <v-container>
                    <v-layout align-center>
                      <v-flex text-xs-center xs12>
                        <h1 class='display-1>'> {{beers[selectedElement.id].name}} </h1>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-jumbotron>
              </v-card>
      </div>
    </div>
	</div>
</template>
<script>
  // import anime from 'animejs'
  import {firestore, db} from '@/firebase/firebase.js'
  import anime from 'animejs'

  export default {
    name: 'zoompick',
    data () {
      return {
        images: {},
        imageCount: 0,
        gif: '',
        selectedElement: '',
        origionalOffset: 0,
        slotPosition: 100,
        slotTop: -100
      }
    },
    mounted: function () {
    },
    computed: {
      zoomed: function () {
        return this.selectedElement !== ''
      },
      beerName: function (id) {
        this.beers[id]
      }
    },
    methods: {
      beerClick: function (ele) {
        var target = ele.target
        this.animate(target)
      },
      focusTarget: function (target, beerTimeline) {
        this.selectedElement = target
        let elements = document.querySelectorAll('.beerImg')
        for (var i = 0; i < elements.length; i = i + 1) {
          elements[i].classList.add('focalblur')
        }
        target.style.zIndex = '2'
        target.classList.remove('focalblur')
        var element = document.querySelector('#zoompick')
        var mWidth = element.getBoundingClientRect().width
        var mHeight = element.getBoundingClientRect().height
        this.origionalOffset = (mWidth / 4) - target.getBoundingClientRect().left

        beerTimeline.add({
          targets: target,
          translateX: this.origionalOffset,
          translateY: mHeight,
          scale: 2,
          duration: 400
        })
      },
      restore: function (beerTimeline) {
        if (this.selectedElement !== '') {
          let elements = document.querySelectorAll('.beerImg')
          for (var i = 0; i < elements.length; i = i + 1) {
            elements[i].style.zIndex = '0'
            elements[i].classList.remove('focalblur')
          }

          beerTimeline.add({
            targets: this.selectedElement,
            scale: 1,
            duration: 100
          })
          this.origionalCoor = 0
          this.selectedElement = ''
        }
      },
      animate: function (target) {
        let beerTimeline = anime.timeline({
          easing: 'easeInOutSine'

        })
        let repeat = this.selectedElement === target
        if (this.selectedElement !== '') {
          this.restore(beerTimeline)
        }
        if (!repeat) {
          this.focusTarget(target, beerTimeline)
        }
      }
    },
    watch: {
      images: function () {
        this.$nextTick(function () {
          let elements = document.querySelectorAll('.beerImg')
          let mWidth = document.querySelector('#zoompick').getBoundingClientRect().width
          let mBottom = document.querySelector('#zoompick').getBoundingClientRect().bottom
          let boarder = 25
          let elemWidth = ((mWidth - (boarder * elements.length)) / (elements.length + 4))
          this.slotPosition = elemWidth + boarder

          for (var i = 0; i < elements.length; i = i + 1) {
            elements[i].width = elemWidth - boarder
            elements[i].style.left = (boarder + ((elemWidth + boarder) * i)) + 'px'
            elements[i].style.bottom = mBottom
          }
        })
      }
    },
    firebase: function () {
      return {
        beers: {
          source: db.ref('/zeptobrew'),
          asObject: true,
          readyCallback: function () {
            var that = this
            for (var key in that.beers) {
              if (!key.startsWith('.')) {
                that.imageCount = that.imageCount + 1
                let pathRef = firestore.ref(that.beers[key].image)
                let beerkey = key
                pathRef.getDownloadURL().then(function (url) {
                  that.$set(that.images, beerkey, url)
                  // that.images[beerkey] = url
                })
              }
            }
          }
        }
      }
    }
  }
</script>
<style>
.focalblur { filter: url(#outofplane); }
</style>


// WEBPACK FOOTER //
// src/components/animations/ZoomPicker.vue